import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://eiagaggqxqweipsfseem.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVpYWdhZ2dxeHF3ZWlwc2ZzZWVtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI1NDkyNjIsImV4cCI6MjA5ODEyNTI2Mn0.AAiv5WPW6icIB8qs-97sVeV01gaXd_MXMNf3dh8fCfQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);